var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"direction":_vm.direction}},[_c('img',{attrs:{"src":_vm.src,"alt":"image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }